/**
 * NewBriefPage — full-page, dedicated URL for the Friction Audit intake.
 * Rendered when the user pops the Brief Intake floating window out of the
 * OS into its own browser tab. Reuses the exact same `<FrictionAudit />`
 * component that the marketing page mounts, so behaviour and validation
 * stay identical.
 */
import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import FrictionAudit from "@/components/FrictionAudit";

export default function NewBriefPage() {
  return (
    <div className="min-h-screen bg-[#0A0F1C] text-nex-silver">
      <header className="w-full border-b border-white/10">
        <div className="w-full max-w-5xl mx-auto flex items-center justify-between gap-4 px-6 py-4">
          <Link
            to="/os"
            data-testid="new-brief-back-to-os"
            className="inline-flex items-center gap-2 px-3 py-1.5 border border-white/10 hover:border-nex-gold/50 text-nex-chrome hover:text-nex-gold font-mono text-[0.7rem] tracking-[0.22em] uppercase transition-all duration-200 no-underline"
          >
            <ArrowLeft className="w-3.5 h-3.5" /> Back to OS
          </Link>
          <div className="font-mono text-[0.7rem] tracking-[0.24em] text-nex-gold uppercase">
            // Full Friction Audit · Dedicated Page
          </div>
        </div>
      </header>
      <FrictionAudit />
    </div>
  );
}
